import {createSlice} from '@reduxjs/toolkit';

const INITIAL_STATE = {
  document: {
    sections: [],
    pageNumberRules: [],
    settings: {
      table: {
        roundNumbersTo: 0,
        decimalPlaces: 0,
      },
      text: {
        roundNumbersTo: 0,
        decimalPlaces: 0,
        appendLabel: 0,
      },
      layout: {},
      pagination: {
        pageNumberAlignment: null,
        widowOrphanControlEnabled: false,
      },
      currency: 'USD',
    },
  },
  // Deny by default: empty permissions means no access until backend provides them
  access: {
    groups: [],
    permissions: [],
  },
  readOnly: false,
};

export const documentsSlice = createSlice({
  name: 'documents',
  initialState: INITIAL_STATE,
  reducers: {
    setDocument: (state, action) => {
      state.document = {
        // Merge payload into existing document so "sections only" updates don't wipe documentId/isFinal
        ...state.document,
        ...action.payload.document,
        settings: {
          pagination: {
            ...state.document.settings?.pagination,
            ...action.payload.document.settings?.pagination,
          },
          table: {
            ...state.document.settings?.table,
            ...action.payload.document.settings?.table,
          },
          text: {
            ...state.document.settings?.text,
            ...action.payload.document.settings?.text,
          },
          layout: {
            ...state.document.settings?.layout,
            ...action.payload.document.settings?.layout,
          },
          currency:
            action.payload.document.settings?.currency ||
            state.document.settings?.currency,
        },
      };
    },
    setDocumentAccess: (state, action) => {
      state.access = action.payload.access;
    },
    setReadOnly: (state, action) => {
      state.readOnly = action.payload.readOnly;
    },
    setTableSettings: (state, action) => {
      state.document.settings.table = {
        ...state.document.settings.table,
        ...action.payload.table,
      };
    },
    setTextSettings: (state, action) => {
      state.document.settings.text = {
        ...state.document.settings.text,
        ...action.payload.text,
      };
    },
    setCurrency: (state, action) => {
      state.document.settings.currency = action.payload.currency;
    },
    setLayoutSettings: (state, action) => {
      state.document.settings.layout = {
        ...(state.document.settings.layout || {}),
        ...action.payload.layout,
      };
    },
    setPaginationSettings: (state, action) => {
      state.document.settings.pagination = {
        ...(state.document.settings.pagination || {}),
        ...action.payload.pagination,
      };
    },
    reset: () => INITIAL_STATE,
  },
});

export const {
  reset,
  setDocument,
  setDocumentAccess,
  setReadOnly,
  setTableSettings,
  setTextSettings,
  setCurrency,
  setLayoutSettings,
  setPaginationSettings,
} = documentsSlice.actions;
export default documentsSlice.reducer;

export const selectWidowOrphanControlEnabled = (state) =>
  Boolean(
    state.documents.document.settings?.pagination?.widowOrphanControlEnabled
  );
